export const checkGroupList = [
  {
    key: 'sex',
    label: '性别',
    type: 'radio',
    list: [
      { label: '男', value: '[1,"男"]' },
      { label: '女', value: '[1,"女"]' }
    ]
  },
  {
    key: 'area',
    label: '地区',
    type: 'checkbox',
    list: [
      { label: '北京', value: '[0,"北京"]' },
      { label: '天津', value: '[5,"天津"]' },
      { label: '河北', value: '[2.5,"河北"]' },
      { label: '山西', value: '[5,"山西"]' },
      { label: '内蒙古', value: '[8,"内蒙古"]' },
      { label: '辽宁', value: '[3,"辽宁"]' },
      { label: '吉林', value: '[5,"吉林"]' },
      { label: '黑龙江', value: '[5,"黑龙江"]' },
      { label: '上海', value: '[1,"上海"]' },
      { label: '江苏', value: '[1,"江苏"]' },
      { label: '浙江', value: '[1,"浙江"]' },
      { label: '安徽', value: '[3,"安徽"]' },
      { label: '福建', value: '[2.5,"福建"]' },
      { label: '江西', value: '[3,"江西"]' },
      { label: '山东', value: '[2.5,"山东"]' },
      { label: '河南', value: '[2.5,"河南"]' },
      { label: '湖北', value: '[2.5,"湖北"]' },
      { label: '湖南', value: '[3,"湖南"]' },
      { label: '广东', value: '[1,"广东"]' },
      { label: '广西', value: '[3,"广西"]' },
      { label: '海南', value: '[18,"海南"]' },
      { label: '四川', value: '[2.5,"四川"]' },
      { label: '贵州', value: '[8,"贵州"]' },
      { label: '云南', value: '[8,"云南"]' },
      { label: '西藏', value: '[18,"西藏"]' },
      { label: '重庆', value: '[3,"重庆"]' },
      { label: '陕西', value: '[3,"陕西"]' },
      { label: '甘肃', value: '[8,"甘肃"]' },
      { label: '青海', value: '[18,"青海"]' },
      { label: '宁夏', value: '[18,"宁夏"]' },
      { label: '新疆', value: '[18,"新疆"]' }
    ]
  },
  {
    key: 'marriage',
    label: '婚姻状况',
    type: 'radio',
    list: [
      { label: '未婚', value: '[1.5,"未婚"]' },
      { label: '已婚', value: '[1.5,"已婚"]' },
      { label: '已有子女', value: '[3,"已有子女"]' }
    ]
  },
  {
    key: 'age',
    label: '年龄段',
    type: 'checkbox',
    list: [
      { label: '18岁以下', value: '[9,"18岁以下"]' },
      { label: '18-25岁', value: '[1.5,"18-25岁"]' },
      { label: '26-30岁', value: '[1.5,"26-30岁"]' },
      { label: '31-40岁', value: '[3,"31-40岁"]' },
      { label: '41-45岁', value: '[5,"41-45岁"]' },
      { label: '46岁以上', value: '[9,"46岁以上"]' }
    ]
  },
  {
    key: 'industry',
    label: '行业',
    type: 'checkbox',
    list: [
      { label: 'IT/互联网', value: '[4,"IT/互联网"]' },
      { label: '餐饮/酒店/旅游', value: '[5,"餐饮/酒店/旅游"]' },
      { label: '制造业', value: '[4,"制造业"]' },
      { label: '金融业', value: '[6,"金融业"]' },
      { label: '物流业', value: '[7,"物流业"]' },
      { label: '建筑/房地产', value: '[6,"建筑/房地产"]' }
    ]
  },
  {
    key: 'jobExp',
    label: '工作经历',
    type: 'checkbox',
    list: [
      { label: '在校高中生', value: '[9,"在校高中生"]' },
      { label: '在校大学生', value: '[2,"在校大学生"]' },
      { label: '1年以内', value: '[3,"1年以内"]' },
      { label: '1-3年', value: '[2,"1-3年"]' },
      { label: '3-8年', value: '[1,"3-8年"]' },
      { label: '8年以上', value: '[3,"8年以上"]' }
    ]
  },
  {
    key: 'wages',
    label: '个人月收入',
    type: 'checkbox',
    list: [
      { label: '3000元以下', value: '[7,"3000元以下"]' },
      { label: '3001-5000元', value: '[4,"3001-5000元"]' },
      { label: '5001-10000元', value: '[3,"5001-10000元"]' },
      { label: '10001-15000元', value: '[5,"10001-15000元"]' },
      { label: '15001-20000元', value: '[9,"15001-20000元"]' },
      { label: '20001元以上', value: '[13,"20001元以上"]' }
    ]
  },
  {
    key: 'job',
    label: '职位',
    type: 'checkbox',
    list: [
      { label: '一般员工', value: '[1,"一般员工"]' },
      { label: '基层管理人员', value: '[2,"基层管理人员"]' },
      { label: '中层管理人员', value: '[4,"中层管理人员"]' },
      { label: '高层管理人员', value: '[9,"高层管理人员"]' }
    ]
  },
  {
    key: 'degree',
    label: '学历',
    type: 'checkbox',
    list: [
      { label: '高中及以下', value: '[8,"高中及以下"]' },
      { label: '大专', value: '[2,"大专"]' },
      { label: '本科', value: '[1,"本科"]' },
      { label: '研究生及以上', value: '[5,"研究生及以上"]' }
    ]
  },
  {
    key: 'specificThrong',
    label: '特定人群',
    type: 'radio',
    list: [
      { label: '微信', value: '[1,"微信"]' },
      { label: '微博', value: '[1,"微博"]' },
      { label: '直播购物经历', value: '[3,"直播购物经历"]' },
      { label: '游戏玩家', value: '[1,"游戏玩家"]' },
      { label: '私家车主', value: '[2,"私家车主"]' },
      { label: '电商从业者', value: '[7,"电商从业者"]' },
      { label: '股民', value: '[4,"股民"]' },
      { label: '有过境外旅游', value: '[4,"有过境外旅游"]' },
      { label: '外卖员', value: '[5,"外卖员"]' }
    ]
  },
];